<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Novo Vendedor
        </span>
      </h3>
    </div>
    <Form url="/vendedor/create" :vendedor="vendedor" />
  </div>
</template>

<script>
import Form from "./Form.vue";
import VendedorData from "./VendedorData";
import { mapGetters } from "vuex";

export default {
  name: "app-vendedor-create",
  data() {
    return {
      vendedor: new VendedorData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
